module.exports = __webpack_public_path__ + "img/stars.2bc784ba.svg";